export default __webpack_public_path__ + "static/23_19-f54eaab51e8fbe3c9bd78d7dbbca25b3.png";